import { DateRange, Option, SplitBy } from "@intentsify/types";
import { atom } from "jotai";
import { atomWithReset, useResetAtom } from "jotai/utils";
import { ViewEnum } from "screens/IntentAnalysis/screens/CampaignsTrendingDomains/CampaignsTrendingDomains.types";
import { TrendingKeywordsOptions } from "screens/IntentAnalysis/screens/CampaignsTrendingSignals/CampaignsTrendingSignals.types";

export const trendingKeywordsDateRangeAtom = atomWithReset<DateRange>(
  DateRange.LastFourWeeks
);

export const keywordsSplitByAtom = atomWithReset<SplitBy>(SplitBy.OneWeek);

export const keywordsViewAtom = atomWithReset<ViewEnum>(ViewEnum.TimeSeries);

export const selectedTrendingKeywordsAtom = atomWithReset<{
  campaignId: number | undefined;
  data: Array<Option<string>>;
}>({
  campaignId: undefined,
  data: [],
});

export const trendingKeywordsOptionsStateAtom =
  atomWithReset<TrendingKeywordsOptions>({
    isLoading: true,
    keywords: [],
  });

export const trendingKeywordsStateSelector = atom((get) => {
  const { isLoading, keywords } = get(trendingKeywordsOptionsStateAtom);
  const selectedDateRange = get(trendingKeywordsDateRangeAtom);
  const selectedSplitBy = get(keywordsSplitByAtom);
  const selectedView = get(keywordsViewAtom);
  const selectedKeywords = get(selectedTrendingKeywordsAtom);

  return {
    isLoading,
    keywordsOptions: keywords,
    selectedDateRange,
    selectedSplitBy,
    selectedView,
    selectedKeywords,
  };
});

export const useResetTrendingKeywordsState = () => {
  const resetOptions = useResetAtom(trendingKeywordsOptionsStateAtom);
  const resetDateRange = useResetAtom(trendingKeywordsDateRangeAtom);
  const resetSplitBy = useResetAtom(keywordsSplitByAtom);
  const resetView = useResetAtom(keywordsViewAtom);
  const resetKeywords = useResetAtom(selectedTrendingKeywordsAtom);

  return () => {
    resetOptions();
    resetDateRange();
    resetSplitBy();
    resetView();
    resetKeywords();
  };
};
